export default {
  namespaced: true,
  state: {
    actionHistory: [],
    quickActionMessage: '',
    isPerformingAction: false
  },
  mutations: {
    ADD_ACTION_HISTORY(state, action) {
      state.actionHistory.unshift({
        id: Date.now(),
        timestamp: new Date().toLocaleString(),
        type: action.type,
        details: action.details
      })
      // Keep only last 10 actions
      if (state.actionHistory.length > 10) {
        state.actionHistory = state.actionHistory.slice(0, 10)
      }
    },
    SET_QUICK_ACTION_MESSAGE(state, message) {
      state.quickActionMessage = message
    },
    SET_PERFORMING_ACTION(state, isPerforming) {
      state.isPerformingAction = isPerforming
    },
    RESET_ACTIONS_STATE(state) {
      state.actionHistory = []
      state.quickActionMessage = ''
      state.isPerformingAction = false
    }
  },
  actions: {
    async performQuickAction({ commit }, action) {
      commit('SET_PERFORMING_ACTION', true)
      try {
        // Simulate action performance
        await new Promise(resolve => setTimeout(resolve, 1000))
        
        commit('ADD_ACTION_HISTORY', {
          type: 'Quick Action',
          details: action
        })
        
        commit('SET_QUICK_ACTION_MESSAGE', `Action performed: ${action}`)
        
        // Clear message after 3 seconds
        setTimeout(() => {
          commit('SET_QUICK_ACTION_MESSAGE', '')
        }, 3000)
        
      } catch (error) {
        console.error('Error performing action:', error)
      } finally {
        commit('SET_PERFORMING_ACTION', false)
      }
    }
  },
  getters: {
    actionHistory: state => state.actionHistory,
    quickActionMessage: state => state.quickActionMessage,
    isPerformingAction: state => state.isPerformingAction
  }
}
